// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as MotionComponentsMjs from "./MotionComponents.mjs";

var make = MotionComponentsMjs.div;

var Div = {
  make: make
};

var make$1 = MotionComponentsMjs.button;

var Button = {
  make: make$1
};

function Motion$Inview(props) {
  return React.createElement(make, {
              initial: "offscreen",
              whileInView: "onscreen",
              className: props.className,
              children: Caml_option.some(props.children)
            });
}

var Inview = {
  make: Motion$Inview
};

export {
  Div ,
  Button ,
  Inview ,
}
/* make Not a pure module */
